import React from 'react';
import { Button, Modal } from 'is24-corecss';
import { getErrorMessage, getSuccessMessage } from '../../../../common/statusMesssages';
import { StatusMessageType } from '../../types/StatusMessageType';
import { performLifecycleTransition } from '../../../../api/TeamApi';

type CompleteTeamReviewModalProps = {
  visible: boolean;
  onClose: () => void;
  onTeamReviewCompleted: (status?: StatusMessageType) => void;
};

const CompleteTeamReviewModal: React.FC<CompleteTeamReviewModalProps> = ({
  visible,
  onClose,
  onTeamReviewCompleted,
}: CompleteTeamReviewModalProps) => {
  const handleCompleteTeamReview = async () => {
    try {
      await performLifecycleTransition({ command: 'teamCompleteReview' });
      onTeamReviewCompleted(getSuccessMessage('teammanagement.completeReview.success'));
    } catch (e) {
      onTeamReviewCompleted(getErrorMessage(e));
    }
  };

  return (
    <Modal visible={visible} onClose={onClose} title='Verifizieren Sie bitte Ihre Benutzerkonten'>
      <div data-testid='complete-team-review-confirmation-text' className='grid-item one-whole padding-bottom-l'>
        <p className='font-bold'>Hiermit verifiziere ich, dass bei allen Unterkonten die korrekten Namen und E-Mail Adressen hinterlegt sind</p>
      </div>
      <div className='grid grid-flex grid-justify-space-between margin-top-m'>
        <Button data-testid='cancel-review-completion-button' onClick={onClose}>
          Abbrechen
        </Button>
        <div className='palm-one-whole margin-top-l desk-hide lap-hide' />
        <Button data-testid='perform-review-completion-button' appearance='primary' onClick={handleCompleteTeamReview}>
          Weiter
        </Button>
      </div>
    </Modal>
  );
};

export default CompleteTeamReviewModal;
